"use client";

import Image, { StaticImageData } from "next/image";
import { useEffect, useState } from "react";

interface ProgressiveImageProps {
    lowSrc: StaticImageData;
    highSrc: StaticImageData;
    alt: string;
    className?: string;
    classLowRes: string;
    width: number;
    height: number;
    noRef?: boolean;
    sizes?: string;
    quality?: number;
}

export default function ProgressiveImage({
                                             lowSrc,
                                             highSrc,
                                             alt,
                                             className = "",
                                             width,
                                             height,
                                             classLowRes,
                                             noRef,
                                             sizes,
                                             quality
                                         }: ProgressiveImageProps) {
    const [loadedHighRes, setLoadedHighRes] = useState(false);

    useEffect(() => {
        const img = new window.Image();
        img.src = highSrc.src;
        img.onload = () => setLoadedHighRes(true);
    }, [highSrc]);

    const commonProps = {
        width,
        height,
        alt,
        ...(noRef ? { loading: "lazy" as const, referrerPolicy: "no-referrer" as const } : {}),
    };

    return (
        <div
            className={`${className}`}
            style={{ width, height }}
        >
            <Image
                {...commonProps}
                src={lowSrc}
                width={lowSrc.width}
                height={lowSrc.height}
                className={classLowRes}
                placeholder="blur"
                blurDataURL={(lowSrc).blurDataURL}
                style={{
                    position: "absolute",
                    zIndex: 2,
                    opacity: loadedHighRes ? 0 : 1,
                    transition: "opacity 0.5s ease",
                    display: loadedHighRes ? 'none' : 'block'
                }}
            />
            {loadedHighRes && (
                <Image
                    src={highSrc}
                    alt={alt}
                    width={width}
                    height={height}
                    quality={quality ?? 60}
                    style={{
                        position: "absolute",
                        zIndex: 1,
                        opacity: 1,
                        transition: "opacity 0.5s ease",
                    }}
                    {...(noRef
                        ? { loading: "lazy", referrerPolicy: "no-referrer" }
                        : { priority: true })}
                />
            )}
        </div>
    );
}